export const SET_PENDING_DEEP_LINK = 'FAN_SELLER:SET_PENDING_DEEP_LINK';
export const CLEAR_PENDING_DEEP_LINK = 'FAN_SELLER:CLEAR_PENDING_DEEP_LINK';

export const openEditListingDeepLink = ({ postingId }) => (dispatch) => {
  const url = new URL(window.location.href);
  url.searchParams.delete('action');
  window.history.replaceState({}, '', url.toString());
  dispatch({ type: SET_PENDING_DEEP_LINK, postingId });
};
